<template>
   <div>
      <TrackingPedido />
   </div>
</template>

<script>
import TrackingPedido from "../components/TrackingPedido.vue";

export default {
   components: {
      TrackingPedido,
   },
   data: () => ({
      //
   }),
};
</script>
